<p-tabView [(activeIndex)]="activeFasePanelIndex" (onChange)="onFaseTabChange($event)" styleClass="p-tabview-no-gap">
    <p-tabPanel header="Fase 1">
        <p-tabView [(activeIndex)]="activeBandoPanelIndex" (onChange)="onBandoTabChange($event)" styleClass="p-tabview-no-gap">
          <p-tabPanel header="Bando 1"> 
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
            <div>
              <p-dropdown 
                styleClass="ml-2 fieldFilterControl" 
                [options]="listeService.opzioniRegioneProntofibra"
                optionLabel="label"
                optionValue="value"
                (onChange)="filtraPerRegione($event.value)"
                placeholder="Regione"
                [showClear]="false"
                [filter]="false"
                [(ngModel)]="filtroRegione"
              />
              <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
                pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
              ></button>
            </div>
            <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
              <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelRegioni}}</span>
            </div>
            <button 
              pButton type="button" icon="pi pi-cloud-download"
              pTooltip="Esporta i dati" tooltipPosition="top"
              class="font-['Poppins']"
              style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
              (click)="scaricaReport()" 
            ></button>
          </div>
          <p-table styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" 
          [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
          [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiFase1Bando1Filtrati" dataKey="impresa"
          >
          <ng-template pTemplate="header">
            <tr>
              <th class="text-left font-['Poppins']" style="font-size: 10px; width: 10%; ">IMPRESA</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">01. F1 da assegnare (no ODA)</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">02. F1 da Accettare con ODA</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">03. F1 in carico con ODA</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">04. SPR Pianificato</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">05. Sopralluogo KO</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">06. Sopralluogo OK</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">07. Sopralluogo OK (extra)</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">08. Extra KO</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">09. Extra Approvato</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">10. Doc. F1 consegnata</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">11. Doc. F1 verifica SF</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">12. Doc. F1 Rework Azienda</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">13. Doc. F1 in firma</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">14. Doc. F1 respinta</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">15. Doc. F1 a Infratel</th>
              <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">16. Doc. F1 Approvata</th>
              <th class="text-center font-['Poppins'] font-bold" style="font-size: 9px;width: 5%;">TOTALE</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>

            <tr>
              <td>
                <p-tag [value]="(row.impresa | uppercase) || ''"
                  style="background-color: #5f9ea0; color: #ffffff; border-radius: 5px; padding: .25em .3rem; font-weight: 700; font-size: 12px; letter-spacing: .3px; cursor: pointer !important; display: inline-block; min-width: 50px;"
                  (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                  [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                  tooltipPosition="top">
                  {{row.impresa | uppercase}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.inAttesaODA > 0" [value]="row.inAttesaODA"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'inAttesaODA')"
                  [pTooltip]="!isPresidioTIM && row.inAttesaODA > 0 ?'Apri le pratiche IN ATTESA DI ODA di ' + row.impresa:null" tooltipPosition="top"
               >{{row.inAttesaODA}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.daAssegnare > 0" [value]="row.daAssegnare"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'daAssegnare')"
                  [pTooltip]="!isPresidioTIM && row.daAssegnare > 0 ?'Apri le pratiche DA ASSEGNARE di ' + row.impresa:null" tooltipPosition="top"
                >{{row.daAssegnare}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.assegnate > 0" [value]="row.assegnate"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'assegnate')"
                  [pTooltip]="!isPresidioTIM && row.assegnate > 0 ?'Apri le pratiche ASSEGNATE di ' + row.impresa:null" tooltipPosition="top"
                >{{row.assegnate}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.sopralluogoPianificato > 0" [value]="row.sopralluogoPianificato"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'sopralluogoPianificato')"
                    [pTooltip]="!isPresidioTIM && row.sopralluogoPianificato > 0 ?'Apri le pratiche SOPRALLUOGO PIANIFICATO di ' + row.impresa:null" tooltipPosition="top"
                >{{row.sopralluogoPianificato}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.sopralluogoKO > 0" [value]="row.sopralluogoKO"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700', 
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'sopralluogoKO')"
                  [pTooltip]="!isPresidioTIM && row.sopralluogoKO > 0 ?'Apri le pratiche SOPRALLUOGO KO di ' + row.impresa:null" tooltipPosition="top"
                >{{row.sopralluogoKO}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.sopralluogoEseguito > 0" [value]="row.sopralluogoEseguito"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'sopralluogoEseguito')"
                  [pTooltip]="!isPresidioTIM && row.sopralluogoEseguito > 0 ?'Apri le pratiche SOPRALLUOGO ESEGUITO di ' + row.impresa:null" tooltipPosition="top"
                >{{row.sopralluogoEseguito}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.preventivoInAttesa > 0" [value]="row.preventivoInAttesa"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'preventivoInAttesa')"
                    [pTooltip]="!isPresidioTIM && row.preventivoInAttesa > 0 ?'Apri le pratiche PREVENTIVO IN ATTESA di ' + row.impresa:null" tooltipPosition="top"
                >{{row.preventivoInAttesa}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.preventivoRifiutato > 0" [value]="row.preventivoRifiutato"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'preventivoRifiutato')"
                  [pTooltip]="!isPresidioTIM && row.preventivoRifiutato > 0 ?'Apri le pratiche PREVENTIVO RIFIUTATO di ' + row.impresa:null" tooltipPosition="top"
                >{{row.preventivoRifiutato}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.preventivoApprovato > 0" [value]="row.preventivoApprovato"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'preventivoApprovato')"
                  [pTooltip]="!isPresidioTIM && row.preventivoApprovato > 0 ?'Apri le pratiche PREVENTIVO APPROVATO di ' + row.impresa:null" tooltipPosition="top"
                >{{row.preventivoApprovato}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.consegnate > 0" [value]="row.consegnate"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'consegnate')"
                  [pTooltip]="!isPresidioTIM && row.consegnate > 0 ?'Apri le pratiche CONSEGNATE di ' + row.impresa:null" tooltipPosition="top"
                >{{row.consegnate}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.inVerificaSmartfiber > 0" [value]="row.inVerificaSmartfiber"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'inVerificaSmartfiber')"
                  [pTooltip]="!isPresidioTIM && row.inVerificaSmartfiber > 0 ?'Apri le pratiche IN VERIFICA SMARTFIBER di ' + row.impresa:null" tooltipPosition="top"
                >{{row.inVerificaSmartfiber}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.inReworkAzienda > 0" [value]="row.inReworkAzienda"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'inReworkAzienda')"
                  [pTooltip]="!isPresidioTIM && row.inReworkAzienda > 0 ?'Apri le pratiche IN REWORK AZIENDA di ' + row.impresa:null" tooltipPosition="top"
                >{{row.inReworkAzienda}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.inCaricoPresidio > 0" [value]="row.inCaricoPresidio"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'inCaricoPresidio')"
                  [pTooltip]="!isPresidioTIM && row.inCaricoPresidio > 0 ?'Apri le pratiche IN CARICO PRESIDIO di ' + row.impresa:null" tooltipPosition="top"
                >{{row.inCaricoPresidio}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.respinte > 0" [value]="row.respinte"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'respinte')"
                  [pTooltip]="!isPresidioTIM && row.respinte > 0 ?'Apri le pratiche RESPINTI di ' + row.impresa:null" tooltipPosition="top"
                >{{row.respinte}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.pubblicate > 0" [value]="row.pubblicate"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'pubblicate')"
                  [pTooltip]="!isPresidioTIM && row.pubblicate > 0 ?'Apri le pratiche PUBBLICATE di ' + row.impresa:null" tooltipPosition="top"
                >{{row.pubblicate}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag *ngIf="row.approvate > 0" [value]="row.approvate"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '5px',
                    'border-color':'#0A0A0A',
                    'padding': '.15em .3rem',
                    'font-weight': '700',
                    'font-size': '11.5px',
                    'letter-spacing': '.2px;',
                    'cursor': 'pointer',
                  }"
                  (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'approvate')"
                  [pTooltip]="!isPresidioTIM && row.approvate > 0 ?'Apri le pratiche APPROVATE di ' + row.impresa:null" tooltipPosition="top"
                >{{row.approvate}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']">
                <p-tag  [value]="row.totale"
                  [style]="{
                    'background-color': '#5f9ea0',
                     'color': '#191a1b',
                    'border-radius': '5px',
                    'padding': '.25em .4rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '50px'
                  }"
                 (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                 [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                 tooltipPosition="top">
               
                  {{row.totale}}
                </p-tag>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr style="border: none;">
              <td colspan="1" class="text-left" style="font-size: 11px; font-weight: bold; border: none;">TOTALI:</td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1InAttesaODABando1 > 0" [value]="totaliFase1InAttesaODABando1"
                  [style]="{
                    'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'inAttesaODA')"
                       [pTooltip]="'Apri TUTTE le pratiche IN ATTESA DI ODA'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1InAttesaODABando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1DaAssegnareBando1 > 0" [value]="totaliFase1DaAssegnareBando1"
                  [style]="{
                      'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'daAssegnare')"
                       [pTooltip]="'Apri TUTTE le pratiche DA ASSEGNARE'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1DaAssegnareBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1AssegnateBando1 > 0" [value]="totaliFase1AssegnateBando1"
                  [style]="{
                     'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'assegnate')"
                       [pTooltip]="'Apri TUTTE le pratiche ASSEGNATE'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1AssegnateBando1}}
                </p-tag>
              </td>
            
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1SopralluogoPianificatoBando1 > 0" [value]="totaliFase1SopralluogoPianificatoBando1"
                  [style]="{
                      'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'sopralluogoPianificato')"
                       [pTooltip]="'Apri TUTTE le pratiche SOPRALLUOGO PIANIFICATO'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1SopralluogoPianificatoBando1}}
                </p-tag>
              </td>
            
               <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1SopralluogoKOBando1 > 0" [value]="totaliFase1SopralluogoKOBando1"
                  [style]="{
                     'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'sopralluogoKO')"
                       [pTooltip]="'Apri TUTTE le pratiche SOPRALLUOGO KO'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1SopralluogoKOBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1SopralluogoEseguitoBando1 > 0" [value]="totaliFase1SopralluogoEseguitoBando1"
                  [style]="{
                      'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'sopralluogoEseguito')"
                       [pTooltip]="'Apri TUTTE le pratiche SOPRALLUOGO ESEGUITO'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1SopralluogoEseguitoBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1PreventivoInAttesaBando1 > 0" [value]="totaliFase1PreventivoInAttesaBando1"
                  [style]="{
                    'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'preventivoInAttesa')"
                       [pTooltip]="'Apri TUTTE le pratiche PREVENTIVO IN ATTESA'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1PreventivoInAttesaBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1PreventivoApprovatoBando1 > 0" [value]="totaliFase1PreventivoApprovatoBando1"
                  [style]="{
                     'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                      'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'preventivoApprovato')"
                       [pTooltip]="'Apri TUTTE le pratiche PREVENTIVO APPROVATO'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1PreventivoApprovatoBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1PreventivoRifiutatoBando1 > 0" [value]="totaliFase1PreventivoRifiutatoBando1"
                  [style]="{
                      'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'preventivoRifiutato')"
                       [pTooltip]="'Apri TUTTE le pratiche PREVENTIVO RIFIUTATO'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1PreventivoRifiutatoBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1ConsegnateBando1 > 0" [value]="totaliFase1ConsegnateBando1"
                  [style]="{
                     'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'consegnate')"
                       [pTooltip]="'Apri TUTTE le pratiche DOC. F1 CONSEGNATE'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1ConsegnateBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1InVerificaSmartfiberBando1 > 0" [value]="totaliFase1InVerificaSmartfiberBando1"
                  [style]="{
                     'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'inVerificaSmartfiber')"
                       [pTooltip]="'Apri TUTTE le pratiche DOC. F1 IN VERIFICA SMARTFIBER'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1InVerificaSmartfiberBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1InReworkAziendaBando1 > 0" [value]="totaliFase1InReworkAziendaBando1"
                  [style]="{
                     'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'inReworkAzienda')"
                       [pTooltip]="'Apri TUTTE le pratiche DOC. F1 IN REWORK AZIENDA'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1InReworkAziendaBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1InCaricoPresidioBando1 > 0" [value]="totaliFase1InCaricoPresidioBando1"
                  [style]="{
                     'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                        'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'inCaricoPresidio')"
                       [pTooltip]="'Apri TUTTE le pratiche DOC. F1 IN CARICO PRESIDIO'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1InCaricoPresidioBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1RespinteBando1 > 0" [value]="totaliFase1RespinteBando1"
                  [style]="{
                      'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'respinte')"
                       [pTooltip]="'Apri TUTTE le pratiche con DOC. F1 RESPINTA'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1RespinteBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1PubblicateBando1 > 0" [value]="totaliFase1PubblicateBando1"
                  [style]="{
                    'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'pubblicate')"
                       [pTooltip]="'Apri TUTTE le pratiche PUBBLICATE'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1PubblicateBando1}}
                </p-tag>
              </td>
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag *ngIf="totaliFase1ApprovateBando1 > 0" [value]="totaliFase1ApprovateBando1"
                  [style]="{
                      'background-color': '#828282',
                    'color': '#FFFFFF',
                    'border-radius': '5px',
                    'padding': '.15em .3rem',
                    'font-weight': '800',
                    'font-size': '12px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '20px',
                    'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(1,'approvate')"
                       [pTooltip]="'Apri TUTTE le pratiche APPROVATE'" 
                       tooltipPosition="top"
                      >
                  {{totaliFase1ApprovateBando1}}
                </p-tag>
              </td>
            
              <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                <p-tag [value]="totaliFase1Bando1"
                  [style]="{
                     'background-color': '#5f9ea0',
                     'color': '#FFFFFF',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px',
                    'display': 'inline-block',
                    'min-width': '50px'
                  }">
                  {{totaliFase1Bando1}}
                </p-tag>
              </td>
            </tr>
          </ng-template>
          </p-table>
        </p-tabPanel>
          <p-tabPanel header="Bando 2"> 
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <div>
                <p-dropdown 
                styleClass="ml-2 fieldFilterControl" 
                [options]="listeService.opzioniRegioneProntofibra"
                optionLabel="label"
                optionValue="value"
                (onChange)="filtraPerRegione($event.value)"
                placeholder="Regione"
                [showClear]="false"
                [filter]="false"
                [(ngModel)]="filtroRegione"
              />
                <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                  style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
                  pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
                ></button>
              </div>
              <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
                <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelRegioni}}</span>
              </div>
              <button 
                pButton type="button" icon="pi pi-cloud-download"
                pTooltip="Esporta i dati" tooltipPosition="top"
                class="font-['Poppins']"
                style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
                (click)="scaricaReport()" 
              ></button>
            </div>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" 
            [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
            [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiFase1Bando2Filtrati" dataKey="impresa"
            >
            <ng-template pTemplate="header">
              <tr>
                <th class="text-left font-['Poppins']" style="font-size: 10px; width: 10%; ">IMPRESA</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">01. F1 da assegnare (no ODA)</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">02. F1 da Accettare con ODA</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">03. F1 in carico con ODA</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">04. SPR Pianificato</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">05. Sopralluogo KO</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">06. Sopralluogo OK</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">07. Sopralluogo OK (extra)</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">08. Extra KO</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">09. Extra Approvato</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">10. Doc. F1 consegnata</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">11. Doc. F1 verifica SF</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">12. Doc. F1 Rework Azienda</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">13. Doc. F1 in firma</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">14. Doc. F1 respinta</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">15. Doc. F1 a Infratel</th>
                <th class="text-center font-['Poppins']" style="font-size: 8px;width: 5%;">16. Doc. F1 Approvata</th>
                <th class="text-center font-['Poppins'] font-bold" style="font-size: 9px;width: 5%;">TOTALE</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
  
              <tr>
                <td>
                  <p-tag [value]="(row.impresa | uppercase) || ''"
                    [style]="{
                      'background-color': '#5f9ea0',
                      'color': '#ffffff',
                      'border-radius': '5px',
                      'padding': '.25em .3rem',
                      'font-weight': '700',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'cursor': 'pointer',
                      'display': 'inline-block',
                      'min-width': '50px'
                    }"
                    (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                    [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                    tooltipPosition="top">
                    {{row.impresa | uppercase}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inAttesaODA > 0" [value]="row.inAttesaODA"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                
                    }"
                      (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'inAttesaODA')"
                      [pTooltip]="!isPresidioTIM && row.inAttesaODA > 0 ?'Apri le pratiche IN ATTESA DI ODA di ' + row.impresa:null" tooltipPosition="top"
                   >{{row.inAttesaODA}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.daAssegnare > 0" [value]="row.daAssegnare"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'daAssegnare')"
                    [pTooltip]="!isPresidioTIM && row.daAssegnare > 0 ?'Apri le pratiche DA ASSEGNARE di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.daAssegnare}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.assegnate > 0" [value]="row.assegnate"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'assegnate')"
                    [pTooltip]="!isPresidioTIM && row.assegnate > 0 ?'Apri le pratiche ASSEGNATE di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.assegnate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.sopralluogoPianificato > 0" [value]="row.sopralluogoPianificato"
                      [style]="{
                        'background-color': '#EBEBEB',
                        'color': '#000000',
                        'border-radius': '5px',
                        'border-color':'#0A0A0A',
                        'padding': '.15em .3rem',
                        'font-weight': '700',
                        'font-size': '11.5px',
                        'letter-spacing': '.2px;',
                        'cursor': 'pointer',
                      }"
                      (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'sopralluogoPianificato')"
                      [pTooltip]="!isPresidioTIM && row.sopralluogoPianificato > 0 ?'Apri le pratiche SOPRALLUOGO PIANIFICATO di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.sopralluogoPianificato}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.sopralluogoKO > 0" [value]="row.sopralluogoKO"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700', 
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'sopralluogoKO')"
                    [pTooltip]="!isPresidioTIM && row.sopralluogoKO > 0 ?'Apri le pratiche SOPRALLUOGO KO di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.sopralluogoKO}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.sopralluogoEseguito > 0" [value]="row.sopralluogoEseguito"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'sopralluogoEseguito')"
                    [pTooltip]="!isPresidioTIM && row.sopralluogoEseguito > 0 ?'Apri le pratiche SOPRALLUOGO ESEGUITO di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.sopralluogoEseguito}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.preventivoInAttesa  > 0" [value]="row.preventivoInAttesa"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                      (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'preventivoInAttesa')"
                      [pTooltip]="!isPresidioTIM && row.preventivoInAttesa > 0 ?'Apri le pratiche PREVENTIVO IN ATTESA di ' + row.impresa:null" tooltipPosition="top"
                    >{{row.preventivoInAttesa}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.preventivoRifiutato > 0" [value]="row.preventivoRifiutato"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'preventivoRifiutato')"
                    [pTooltip]="!isPresidioTIM && row.preventivoRifiutato > 0 ?'Apri le pratiche PREVENTIVO RIFIUTATO di ' + row.impresa:null" tooltipPosition="top"
                 >{{row.preventivoRifiutato}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.preventivoApprovato > 0" [value]="row.preventivoApprovato"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'preventivoApprovato')"
                    [pTooltip]="!isPresidioTIM && row.preventivoApprovato > 0 ?'Apri le pratiche PREVENTIVO APPROVATO di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.preventivoApprovato}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.consegnate > 0" [value]="row.consegnate"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'consegnate')"
                    [pTooltip]="!isPresidioTIM && row.consegnate > 0 ?'Apri le pratiche CONSEGNATE di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.consegnate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inVerificaSmartfiber > 0" [value]="row.inVerificaSmartfiber"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'inVerificaSmartfiber')"
                    [pTooltip]="!isPresidioTIM && row.inVerificaSmartfiber > 0 ?'Apri le pratiche IN VERIFICA SMARTFIBER di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.inVerificaSmartfiber}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inReworkAzienda > 0" [value]="row.inReworkAzienda"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'inReworkAzienda')"
                    [pTooltip]="!isPresidioTIM && row.inReworkAzienda > 0 ?'Apri le pratiche IN REWORK AZIENDA di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.inReworkAzienda}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inCaricoPresidio > 0" [value]="row.inCaricoPresidio"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'inCaricoPresidio')"
                    [pTooltip]="!isPresidioTIM && row.inCaricoPresidio > 0 ?'Apri le pratiche IN CARICO PRESIDIO di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.inCaricoPresidio}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.respinte > 0" [value]="row.respinte"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'respinte')"
                    [pTooltip]="!isPresidioTIM && row.respinte > 0 ?'Apri le pratiche RESPINTI di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.respinte}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.pubblicate > 0" [value]="row.pubblicate"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'pubblicate')"
                    [pTooltip]="!isPresidioTIM && row.pubblicate > 0 ?'Apri le pratiche PUBBLICATE di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.pubblicate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.approvate > 0" [value]="row.approvate"
                    [style]="{
                      'background-color': '#EBEBEB',
                      'color': '#000000',
                      'border-radius': '5px',
                      'border-color':'#0A0A0A',
                      'padding': '.15em .3rem',
                      'font-weight': '700',
                      'font-size': '11.5px',
                      'letter-spacing': '.2px;',
                      'cursor': 'pointer',
                    }"
                    (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'approvate')"
                    [pTooltip]="!isPresidioTIM && row.approvate > 0 ?'Apri le pratiche APPROVATE di ' + row.impresa:null" tooltipPosition="top"
                  >{{row.approvate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag [value]="row.totale"
                    [style]="{
                      'background-color': '#5f9ea0',
                       'color': '#191a1b',
                      'border-radius': '5px',
                      'padding': '.25em .4rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '50px'
                    }"
                   (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                   [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                   tooltipPosition="top">
                    {{row.totale}}
                  </p-tag>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr style="border: none;">
                <td colspan="1" class="text-left" style="font-size: 11px; font-weight: bold; border: none;">TOTALI:</td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1InAttesaODABando2 > 0" [value]="totaliFase1InAttesaODABando2"
                    [style]="{
                      'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'inAttesaODA')"
                       [pTooltip]="'Apri TUTTE le pratiche IN ATTESA DI ODA'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1InAttesaODABando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1DaAssegnareBando2 > 0" [value]="totaliFase1DaAssegnareBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'daAssegnare')"
                       [pTooltip]="'Apri TUTTE le pratiche DA ASSEGNARE'" 
                       tooltipPosition="top"
                      >
                            {{totaliFase1DaAssegnareBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1AssegnateBando2 > 0" [value]="totaliFase1AssegnateBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'assegnate')"
                       [pTooltip]="'Apri TUTTE le pratiche ASSEGNATE'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1AssegnateBando2}}
                  </p-tag>
                </td>
              
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1SopralluogoPianificatoBando2 > 0" [value]="totaliFase1SopralluogoPianificatoBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'sopralluogoPianificato')"
                       [pTooltip]="'Apri TUTTE le pratiche SOPRALLUOGO PIANIFICATO'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1SopralluogoPianificatoBando2}}
                  </p-tag>
                </td>
              
                 <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1SopralluogoKOBando2 > 0" [value]="totaliFase1SopralluogoKOBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'sopralluogoKO')"
                       [pTooltip]="'Apri TUTTE le pratiche SOPRALLUOGO KO'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1SopralluogoKOBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1SopralluogoEseguitoBando2 > 0" [value]="totaliFase1SopralluogoEseguitoBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                        'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'sopralluogoEseguito')"
                       [pTooltip]="'Apri TUTTE le pratiche SOPRALLUOGO ESEGUITO'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1SopralluogoEseguitoBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1PreventivoInAttesaBando2 > 0" [value]="totaliFase1PreventivoInAttesaBando2"
                    [style]="{
                      'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'preventivoInAttesa')"
                       [pTooltip]="'Apri TUTTE le pratiche PREVENTIVO IN ATTESA'" 
                       tooltipPosition="top"
                      >
                      {{totaliFase1PreventivoInAttesaBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1PreventivoApprovatoBando2 > 0" [value]="totaliFase1PreventivoApprovatoBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'preventivoApprovato')"
                       [pTooltip]="'Apri TUTTE le pratiche PREVENTIVO APPROVATO'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1PreventivoApprovatoBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1PreventivoRifiutatoBando2 > 0" [value]="totaliFase1PreventivoRifiutatoBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'preventivoRifiutato')"
                       [pTooltip]="'Apri TUTTE le pratiche PREVENTIVO RIFIUTATO'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1PreventivoRifiutatoBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1ConsegnateBando2 > 0" [value]="totaliFase1ConsegnateBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'consegnate')"
                       [pTooltip]="'Apri TUTTE le pratiche CONSEGNATE'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1ConsegnateBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1InVerificaSmartfiberBando2 > 0" [value]="totaliFase1InVerificaSmartfiberBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'inVerificaSmartfiber')"
                       [pTooltip]="'Apri TUTTE le pratiche IN VERIFICA SMARTFIBER'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1InVerificaSmartfiberBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1InReworkAziendaBando2 > 0" [value]="totaliFase1InReworkAziendaBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'inReworkAzienda')"
                       [pTooltip]="'Apri TUTTE le pratiche IN REWORK AZIENDA'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1InReworkAziendaBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1InCaricoPresidioBando2 > 0" [value]="totaliFase1InCaricoPresidioBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'inCaricoPresidio')"
                       [pTooltip]="'Apri TUTTE le pratiche IN CARICO PRESIDIO'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1InCaricoPresidioBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1RespinteBando2 > 0" [value]="totaliFase1RespinteBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'respinte')"
                       [pTooltip]="'Apri TUTTE le pratiche RESPINTE'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1RespinteBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1PubblicateBando2 > 0" [value]="totaliFase1PubblicateBando2"
                    [style]="{
                      'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'pubblicate')"
                       [pTooltip]="'Apri TUTTE le pratiche PUBBLICATE'" 
                       tooltipPosition="top"
                      >
                    {{totaliFase1PubblicateBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase1ApprovateBando2 > 0" [value]="totaliFase1ApprovateBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                       (click)="!isImpresa && openPraticheFase1(2,'approvate')"
                       [pTooltip]="'Apri TUTTE le pratiche APPROVATE'" 
                       tooltipPosition="top"
                      >
                      {{totaliFase1ApprovateBando2}}
                  </p-tag>
                </td>
              
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag [value]="totaliFase1Bando2"
                    [style]="{
                       'background-color': '#5f9ea0',
                       'color': '#FFFFFF',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '800',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '50px'
                    }">
                    {{totaliFase1Bando2}}
                  </p-tag>
                </td>
              </tr>
            </ng-template>
            </p-table> 
          </p-tabPanel>
          
        </p-tabView>
      </p-tabPanel>
      <p-tabPanel header="Fase 2">
        <p-tabView [(activeIndex)]="activeBandoPanelIndex" (onChange)="onBandoTabChange($event)" styleClass="p-tabview-no-gap">
          <p-tabPanel header="Bando 1"> 
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <div>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="listeService.opzioniRegioneProntofibra"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerRegione($event.value)"
                  placeholder="Regione"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroRegione"
                />
                <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                  style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
                  pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
                ></button>
              </div>
              <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
                <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelRegioni}}</span>
              </div>
              <button 
                pButton type="button" icon="pi pi-cloud-download"
                pTooltip="Esporta i dati" tooltipPosition="top"
                class="font-['Poppins']"
                style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
                (click)="scaricaReport()" 
              ></button>
            </div>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" 
                [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
                [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiFase2Bando1Filtrati" dataKey="impresa"
                >
                <ng-template pTemplate="header">
                  <tr>
                    <th class="text-left font-['Poppins']" style="font-size: 10px; width: 10%; ">IMPRESA</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">01. F2 Da assegnare (no ODA)</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">02. F2 Da accettare (con ODA)</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">03. F2 In carico con ODA</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">04. Appuntamento KO</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">05. Appuntamento OK</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">06. Router installato</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">07. Attesa TS</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">08. Attivazione KO CPE</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">09. Attivazione KO FO</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">10. Verifica TS KO</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">11. Attivazione OK</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">12. Doc. F2 consegnata</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">13. Doc. F2 Verifica SF</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">14. Doc. F2 in firma</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">15. Doc. F2 a Infratel</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">16. Doc. F2 Respinta</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">17. Doc. F2 Rework</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">18. Doc. F2 Approvata</th>
                    <th class="text-center font-['Poppins'] font-bold" style="font-size: 9px;width: 5%;">TOTALE</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr>
                    <td>
                      <p-tag [value]="(row.impresa | uppercase) || ''"
                        [style]="{
                          'background-color': '#5f9ea0',
                          'color': '#ffffff',
                          'border-radius': '5px',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                          'display': 'inline-block',
                          'min-width': '50px'
                        }"
                        (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                        tooltipPosition="top">
                        {{row.impresa | uppercase}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inAttesaODA > 0" [value]="row.inAttesaODA"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                          (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'inAttesaODA')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in attesa di ODA' "
                          tooltipPosition="top"
                      >{{row.inAttesaODA}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.daAssegnare > 0" [value]="row.daAssegnare"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',  
                          }"
                          (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'daAssegnare')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' da assegnare' "
                          tooltipPosition="top"
                      >{{row.daAssegnare}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.assegnate + row.inCaricoImpresa > 0" [value]="row.assegnate + row.inCaricoImpresa"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                          (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'assegnate')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' assegnate' "
                          tooltipPosition="top"
                      >{{row.assegnate + row.inCaricoImpresa}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.appuntamentoScaduto > 0" [value]="row.appuntamentoScaduto"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                          (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'appuntamentoScaduto')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' appuntamento scaduto' "
                          tooltipPosition="top"
                      >{{row.appuntamentoScaduto}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.appuntamentoFissato > 0" [value]="row.appuntamentoFissato"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                          (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'appuntamentoFissato')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' appuntamento fissato' "
                          tooltipPosition="top"
                      >{{row.appuntamentoFissato}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.installazioneOK > 0" [value]="row.installazioneOK"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'installazioneOK')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' installazione OK' "
                            tooltipPosition="top"
                        >{{row.installazioneOK}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.attesaTS > 0" [value]="row.attesaTS"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attesaTS')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' attesa TS' "
                            tooltipPosition="top"
                        >{{row.attesaTS}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.attivazioneKO_CPE > 0" [value]="row.attivazioneKO_CPE"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attivazioneKO_CPE')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' attivazione KO CPE' "
                            tooltipPosition="top"
                        >{{row.attivazioneKO_CPE}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.attivazioneKO_FO > 0" [value]="row.attivazioneKO_FO"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                              }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attivazioneKO_FO')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' attivazione KO FO' "
                            tooltipPosition="top"
                        >{{row.attivazioneKO_FO}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.verificaTSKO > 0" [value]="row.verificaTSKO"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'verificaTSKO')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' verifica TS KO' "
                            tooltipPosition="top"
                        >{{row.verificaTSKO}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.attivazioneOK > 0" [value]="row.attivazioneOK"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attivazioneOK')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' attivazione OK' "
                            tooltipPosition="top"
                        >{{row.attivazioneOK}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.consegnate > 0" [value]="row.consegnate"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'consegnate')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' consegnate' "
                            tooltipPosition="top"
                        >{{row.consegnate}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inVerificaSmartfiber > 0" [value]="row.inVerificaSmartfiber"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'inVerificaSmartfiber')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in verifica Smartfiber' "
                            tooltipPosition="top"
                        >{{row.inVerificaSmartfiber}}
                      </p-tag>
                    </td>
                   
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inCaricoPresidio > 0" [value]="row.inCaricoPresidio"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                              }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'inCaricoPresidio')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in carico al presidio' "
                            tooltipPosition="top"
                        >{{row.inCaricoPresidio}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.pubblicate > 0" [value]="row.pubblicate"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'pubblicate')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' pubblicate' "
                            tooltipPosition="top"
                        >{{row.pubblicate}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.respinte > 0" [value]="row.respinte"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'respinte')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' respinte' "
                            tooltipPosition="top"
                        >{{row.respinte}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inReworkAzienda > 0" [value]="row.inReworkAzienda"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                                'letter-spacing': '.3px',
                                'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'inReworkAzienda')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in rework azienda' "
                            tooltipPosition="top"
                        >{{row.inReworkAzienda}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.approvate > 0" [value]="row.approvate"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                                'letter-spacing': '.3px',
                                'cursor': 'pointer',
                            }"
                            (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'approvate')"
                            [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' approvate' "
                            tooltipPosition="top"
                        >{{row.approvate}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag  [value]="row.totale"
                        [style]="{
                          'background-color': '#5f9ea0',
                           'color': '#191a1b',
                          'border-radius': '5px',
                          'padding': '.25em .4rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '50px'
                        }"
                        (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in attesa di ODA' "
                        tooltipPosition="top"
                    >
                        {{row.totale}}
                      </p-tag>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                  <tr style="border: none;">
                    <td colspan="1" class="text-left" style="font-size: 11px; font-weight: bold; border: none;">TOTALI:</td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2InAttesaODABando1 > 0" [value]="totaliFase2InAttesaODABando1"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'inAttesaODA')"
                          [pTooltip]="'Apri TUTTE le pratiche in attesa di ODA'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2InAttesaODABando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2DaAssegnareBando1 > 0" [value]="totaliFase2DaAssegnareBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'daAssegnare')"
                          [pTooltip]="'Apri TUTTE le pratiche da assegnare'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2DaAssegnareBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2AssegnateBando1 > 0" [value]="totaliFase2AssegnateBando1"
                        [style]="{
                           'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'assegnate')"
                          [pTooltip]="'Apri TUTTE le pratiche assegnate'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2AssegnateBando1}}
                      </p-tag>
                    </td>
                  
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2AppuntamentoScadutoBando1 > 0" [value]="totaliFase2AppuntamentoScadutoBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'appuntamentoScaduto')"
                          [pTooltip]="'Apri TUTTE le pratiche appuntamento scaduto'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2AppuntamentoScadutoBando1}}
                      </p-tag>
                    </td>
                  
                     <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2AppuntamentoFissatoBando1 > 0" [value]="totaliFase2AppuntamentoFissatoBando1"
                        [style]="{
                           'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'appuntamentoFissato')"
                          [pTooltip]="'Apri TUTTE le pratiche appuntamento fissato'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2AppuntamentoFissatoBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2InstallazioneOKBando1 > 0" [value]="totaliFase2InstallazioneOKBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                            'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'installazioneOK')"
                          [pTooltip]="'Apri TUTTE le pratiche installazione OK'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2InstallazioneOKBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2AttesaTSBando1 > 0" [value]="totaliFase2AttesaTSBando1"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'attesaTS')"
                          [pTooltip]="'Apri TUTTE le pratiche attesa in attesa del riscontro del TIM SUPPORT'"
                          tooltipPosition="top"
                      >
                          {{totaliFase2AttesaTSBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2AttivazioneKO_CPEBando1 > 0" [value]="totaliFase2AttivazioneKO_CPEBando1"
                        [style]="{
                           'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'attivazioneKO_CPE')"
                          [pTooltip]="'Apri TUTTE le pratiche con attivazione KO per problemi al CPE'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2AttivazioneKO_CPEBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2AttivazioneKO_FOBando1 > 0" [value]="totaliFase2AttivazioneKO_FOBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'attivazioneKO_FO')"
                          [pTooltip]="'Apri TUTTE le pratiche con attivazione KO per problemi FO'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2AttivazioneKO_FOBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2VerificaTSKO_Bando1 > 0" [value]="totaliFase2VerificaTSKO_Bando1"
                        [style]="{
                           'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'verificaTSKO')"
                          [pTooltip]="'Apri TUTTE le pratiche con verifica TIM SUPPORT KO'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2VerificaTSKO_Bando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2AttivazioneOKBando1 > 0" [value]="totaliFase2AttivazioneOKBando1"
                        [style]="{
                           'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'attivazioneOK')"
                          [pTooltip]="'Apri TUTTE le pratiche con attivazione OK'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2AttivazioneOKBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2ConsegnateBando1 > 0" [value]="totaliFase2ConsegnateBando1"
                        [style]="{
                           'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'consegnate')"
                          [pTooltip]="'Apri TUTTE le pratiche consegnate'"
                          tooltipPosition="top"
                      >
                          {{totaliFase2ConsegnateBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2InVerificaSmartfiberBando1 > 0" [value]="totaliFase2InVerificaSmartfiberBando1"
                        [style]="{
                           'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'inVerificaSmartfiber')"
                          [pTooltip]="'Apri TUTTE le pratiche in verifica Smartfiber'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2InVerificaSmartfiberBando1}}
                      </p-tag>
                    </td>
                   
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2InCaricoPresidioBando1 > 0" [value]="totaliFase2InCaricoPresidioBando1"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'inCaricoPresidio')"
                          [pTooltip]="'Apri TUTTE le pratiche in carico al presidio'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2InCaricoPresidioBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2PubblicateBando1 > 0" [value]="totaliFase2PubblicateBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                            'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'pubblicate')"
                          [pTooltip]="'Apri TUTTE le pratiche pubblicate'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2PubblicateBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2RespinteBando1 > 0" [value]="totaliFase2RespinteBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'respinte')"
                          [pTooltip]="'Apri TUTTE le pratiche respinte'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2RespinteBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2InReworkAziendaBando1 > 0" [value]="totaliFase2InReworkAziendaBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'inReworkAzienda')"
                          [pTooltip]="'Apri TUTTE le pratiche in rework azienda'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2InReworkAziendaBando1}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2ApprovateBando1 > 0" [value]="totaliFase2ApprovateBando1"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase2(1,'approvate')"
                          [pTooltip]="'Apri TUTTE le pratiche approvate'"
                          tooltipPosition="top"
                      >
                        {{totaliFase2ApprovateBando1}}
                      </p-tag>
                    </td>
                  
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag [value]="totaliFase2Bando1"
                        [style]="{
                           'background-color': '#5f9ea0',
                           'color': '#FFFFFF',
                          'border-radius': '6px',
                          'padding': '.25em .5rem',
                          'font-weight': '800',
                          'font-size': '13px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '50px'
                        }">
                        {{totaliFase2Bando1}}
                      </p-tag>
                    </td>
                  </tr>
                </ng-template>
            </p-table>
          </p-tabPanel>
          <p-tabPanel header="Bando 2"> 
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <div>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="listeService.opzioniRegioneProntofibra"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerRegione($event.value)"
                  placeholder="Regione"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroRegione"
                />
                <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                  style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
                  pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
                ></button>
              </div>
              <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
                <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelRegioni}}</span>
              </div>
              <button 
                pButton type="button" icon="pi pi-cloud-download"
                pTooltip="Esporta i dati" tooltipPosition="top"
                class="font-['Poppins']"
                style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
                (click)="scaricaReport()" 
              ></button>
            </div>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" 
            [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
            [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiFase2Bando2Filtrati" dataKey="impresa"
            >
            <ng-template pTemplate="header">
              <tr>
                <th class="text-left font-['Poppins']" style="font-size: 10px; width: 10%; ">IMPRESA</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">01. F2 Da assegnare (no ODA)</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">02. F2 Da accettare (con ODA)</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">03. F2 In carico con ODA</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">04. Appuntamento KO</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">05. Appuntamento OK</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">06. Router installato</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">07. Attesa TS</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">08. Attivazione KO CPE</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">09. Attivazione KO FO</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">10. Verifica TS KO</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">11. Attivazione OK</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">12. Doc. F2 consegnata</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">13. Doc. F2 Verifica SF</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">14. Doc. F2 in firma</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">15. Doc. F2 a Infratel</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">16. Doc. F2 Respinta</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">17. Doc. F2 Rework</th>
                <th class="text-center font-['Poppins']" style="font-size: 9px;width: 5%;">18. Doc. F2 Approvata</th>
                <th class="text-center font-['Poppins'] font-bold" style="font-size: 9px;width: 5%;">TOTALE</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>
                  <p-tag [value]="(row.impresa | uppercase) || ''"
                    [style]="{
                      'background-color': '#5f9ea0',
                      'color': '#ffffff',
                      'border-radius': '5px',
                      'padding': '.25em .3rem',
                      'font-weight': '700',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'cursor': 'pointer',
                      'display': 'inline-block',
                      'min-width': '50px'
                    }"
                    (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                    [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                    tooltipPosition="top">
                    {{row.impresa | uppercase}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inAttesaODA > 0" [value]="row.inAttesaODA"
                      [style]="{
                        'background-color': '#EBEBEB',
                        'color': '#000000',
                        'border-radius': '5px',
                        'border-color':'#0A0A0A',
                        'padding': '.25em .3rem',
                        'font-weight': '700',
                        'font-size': '11.5px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer',
                      }"
                   (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'inAttesaODA')"
                   [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in attesa di ODA' "
                   tooltipPosition="top">{{row.inAttesaODA}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.daAssegnare > 0" [value]="row.daAssegnare"
                      [style]="{
                        'background-color': '#EBEBEB',
                        'color': '#000000',
                        'border-radius': '5px',
                        'border-color':'#0A0A0A',
                        'padding': '.25em .3rem',
                        'font-weight': '700',
                        'font-size': '11.5px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer',
                      }"
                      (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'daAssegnare')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' da assegnare' "
                      tooltipPosition="top">{{row.daAssegnare}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.assegnate > 0" [value]="row.assegnate"
                      [style]="{
                        'background-color': '#EBEBEB',
                        'color': '#000000',
                        'border-radius': '5px',
                        'border-color':'#0A0A0A',
                        'padding': '.25em .3rem',
                        'font-weight': '700',
                        'font-size': '11.5px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer',
                      }"
                      (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'assegnate')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' assegnate' "
                      tooltipPosition="top">{{row.assegnate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.appuntamentoScaduto > 0" [value]="row.appuntamentoScaduto"
                      [style]="{
                        'background-color': '#EBEBEB',
                        'color': '#000000',
                        'border-radius': '5px',
                        'border-color':'#0A0A0A',
                        'padding': '.25em .3rem',
                        'font-weight': '700',
                        'font-size': '11.5px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer',
                      }"
                      (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'appuntamentoScaduto')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' appuntamento scaduto' "
                      tooltipPosition="top">{{row.appuntamentoScaduto}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.appuntamentoFissato > 0" [value]="row.appuntamentoFissato"
                      [style]="{
                        'background-color': '#EBEBEB',
                        'color': '#000000',
                        'border-radius': '5px',
                        'border-color':'#0A0A0A',
                        'padding': '.25em .3rem',
                        'font-weight': '700',
                        'font-size': '11.5px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer',
                      }"
                      (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'appuntamentoFissato')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' appuntamento fissato' "
                      tooltipPosition="top">{{row.appuntamentoFissato}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.installazioneOK > 0" [value]="row.installazioneOK"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                        (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'installazioneOK')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' installazione OK' "
                        tooltipPosition="top">{{row.installazioneOK}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.attesaTS > 0" [value]="row.attesaTS"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attesaTS')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in attesa di TS' "
                        tooltipPosition="top">{{row.attesaTS}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.attivazioneKO_CPE > 0" [value]="row.attivazioneKO_CPE"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                        (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attivazioneKO_CPE')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' attivazione KO CPE' "
                        tooltipPosition="top">{{row.attivazioneKO_CPE}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.attivazioneKO_FO > 0" [value]="row.attivazioneKO_FO"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                        (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attivazioneKO_FO')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' attivazione KO FO' "
                        tooltipPosition="top">{{row.attivazioneKO_FO}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.verificaTSKO > 0" [value]="row.verificaTSKO"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                          }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'verificaTSKO')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' verifica TS KO' "
                          tooltipPosition="top">{{row.verificaTSKO}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.attivazioneOK > 0" [value]="row.attivazioneOK"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                        (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attivazioneOK')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' attivazione OK' "
                        tooltipPosition="top">{{row.attivazioneOK}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.consegnate > 0" [value]="row.consegnate"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'consegnate')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' consegnate' "
                          tooltipPosition="top">{{row.consegnate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inVerificaSmartfiber > 0" [value]="row.inVerificaSmartfiber"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'inVerificaSmartfiber')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in verifica Smartfiber' "
                          tooltipPosition="top">{{row.inVerificaSmartfiber}}
                  </p-tag>
                </td>
               
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inCaricoPresidio > 0" [value]="row.inCaricoPresidio"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'inCaricoPresidio')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in carico al presidio' "
                          tooltipPosition="top">{{row.inCaricoPresidio}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.pubblicate > 0" [value]="row.pubblicate"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'pubblicate')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' pubblicate' "
                          tooltipPosition="top">{{row.pubblicate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.respinte > 0" [value]="row.respinte"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'respinte')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' respinte' "
                          tooltipPosition="top">{{row.respinte}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.inReworkAzienda > 0" [value]="row.inReworkAzienda"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                        }"
                            (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'inReworkAzienda')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in rework azienda' "
                          tooltipPosition="top">{{row.inReworkAzienda}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag *ngIf="row.approvate > 0" [value]="row.approvate"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                        }"
                          (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'approvate')"
                          [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' approvate' "
                          tooltipPosition="top">{{row.approvate}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']">
                  <p-tag  [value]="row.totale"
                    [style]="{
                      'background-color': '#5f9ea0',
                       'color': '#191a1b',
                      'border-radius': '5px',
                      'padding': '.25em .4rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '50px'
                    }"
                     (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                     tooltipPosition="top">
                    {{row.totale}}
                  </p-tag>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr style="border: none;">
                <td colspan="1" class="text-left" style="font-size: 11px; font-weight: bold; border: none;">TOTALI:</td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2InAttesaODABando2 > 0" [value]="totaliFase2InAttesaODABando2"
                    [style]="{
                      'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'inAttesaODA')"
                      [pTooltip]="'Apri TUTTE le pratiche in attesa di ODA'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2InAttesaODABando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2DaAssegnareBando2 > 0" [value]="totaliFase2DaAssegnareBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'daAssegnare')"
                      [pTooltip]="'Apri TUTTE le pratiche da assegnare'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2DaAssegnareBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2AssegnateBando2 > 0" [value]="totaliFase2AssegnateBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'assegnate')"
                      [pTooltip]="'Apri TUTTE le pratiche assegnate'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2AssegnateBando2}}
                  </p-tag>
                </td>
              
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2AppuntamentoScadutoBando2 > 0" [value]="totaliFase2AppuntamentoScadutoBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'appuntamentoScaduto')"
                      [pTooltip]="'Apri TUTTE le pratiche con appuntamento scaduto'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2AppuntamentoScadutoBando2}}
                  </p-tag>
                </td>
              
                 <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2AppuntamentoFissatoBando2 > 0" [value]="totaliFase2AppuntamentoFissatoBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'appuntamentoFissato')"
                      [pTooltip]="'Apri TUTTE le pratiche con appuntamento fissato'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2AppuntamentoFissatoBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2InstallazioneOKBando2 > 0" [value]="totaliFase2InstallazioneOKBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                          'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'installazioneOK')"
                      [pTooltip]="'Apri TUTTE le pratiche con installazione OK'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2InstallazioneOKBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2AttesaTSBando2 > 0" [value]="totaliFase2AttesaTSBando2"
                    [style]="{
                      'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'attesaTS')"
                      [pTooltip]="'Apri TUTTE le pratiche in attesa di TS'"
                      tooltipPosition="top"
                  >
                      {{totaliFase2AttesaTSBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2AttivazioneKO_CPEBando2 > 0" [value]="totaliFase2AttivazioneKO_CPEBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'attivazioneKO_CPE')"
                      [pTooltip]="'Apri TUTTE le pratiche con attivazione KO PER PROBLEMI AL CPE'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2AttivazioneKO_CPEBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2AttivazioneKO_FOBando2 > 0" [value]="totaliFase2AttivazioneKO_FOBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'attivazioneKO_FO')"
                      [pTooltip]="'Apri TUTTE le pratiche con attivazione KO FO'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2AttivazioneKO_FOBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase2VerificaTSKO_Bando2 > 0" [value]="totaliFase2VerificaTSKO_Bando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'verificaTSKO')"
                      [pTooltip]="'Apri TUTTE le pratiche con verifica TIM SUPPORT KO'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2VerificaTSKO_Bando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2AttivazioneOKBando2 > 0" [value]="totaliFase2AttivazioneOKBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'attivazioneOK')"
                      [pTooltip]="'Apri TUTTE le pratiche con attivazione OK'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2AttivazioneOKBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2ConsegnateBando2 > 0" [value]="totaliFase2ConsegnateBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'consegnate')"
                      [pTooltip]="'Apri TUTTE le pratiche consegnate'"
                      tooltipPosition="top"
                  >
                      {{totaliFase2ConsegnateBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2InVerificaSmartfiberBando2 > 0" [value]="totaliFase2InVerificaSmartfiberBando2"
                    [style]="{
                       'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'inVerificaSmartfiber')"
                      [pTooltip]="'Apri TUTTE le pratiche in verifica Smartfiber'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2InVerificaSmartfiberBando2}}
                  </p-tag>
                </td>
               
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase2InCaricoPresidioBando2 > 0" [value]="totaliFase2InCaricoPresidioBando2"
                    [style]="{
                      'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'inCaricoPresidio')"
                      [pTooltip]="'Apri TUTTE le pratiche in carico al presidio'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2InCaricoPresidioBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase2PubblicateBando2 > 0" [value]="totaliFase2PubblicateBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'pubblicate')"
                      [pTooltip]="'Apri TUTTE le pratiche pubblicate'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2PubblicateBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2RespinteBando2 > 0" [value]="totaliFase2RespinteBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                        'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'respinte')"
                      [pTooltip]="'Apri TUTTE le pratiche respinte'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2RespinteBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2InReworkAziendaBando2 > 0" [value]="totaliFase2InReworkAziendaBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'inReworkAzienda')"
                      [pTooltip]="'Apri TUTTE le pratiche in rework azienda'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2InReworkAziendaBando2}}
                  </p-tag>
                </td>
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                  <p-tag *ngIf="totaliFase2ApprovateBando2 > 0" [value]="totaliFase2ApprovateBando2"
                    [style]="{
                        'background-color': '#828282',
                      'color': '#FFFFFF',
                      'border-radius': '5px',
                      'padding': '.15em .3rem',
                      'font-weight': '800',
                      'font-size': '12px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '20px',
                      'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                      }"
                      (click)="!isImpresa && openPraticheFase2(2,'approvate')"
                      [pTooltip]="'Apri TUTTE le pratiche approvate'"
                      tooltipPosition="top"
                  >
                    {{totaliFase2ApprovateBando2}}
                  </p-tag>
                </td>
              
                <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag [value]="totaliFase2Bando2"
                    [style]="{
                       'background-color': '#5f9ea0',
                       'color': '#FFFFFF',
                      'border-radius': '6px',
                      'padding': '.25em .5rem',
                      'font-weight': '800',
                      'font-size': '13px',
                      'letter-spacing': '.3px',
                      'display': 'inline-block',
                      'min-width': '50px'
                    }">
                    {{totaliFase2Bando2}}
                  </p-tag>
                </td>
              </tr>
            </ng-template>
            </p-table>
          </p-tabPanel>
        </p-tabView>
      </p-tabPanel>
      <p-tabPanel header="Fase 3">
        <p-tabView [(activeIndex)]="activeBandoPanelIndex" (onChange)="onBandoTabChange($event)" styleClass="p-tabview-no-gap">
          <p-tabPanel header="Bando 1"> 
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <div>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="listeService.opzioniRegioneProntofibra"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerRegione($event.value)"
                  placeholder="Regione"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroRegione"
                />
               <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                  style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
                  pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
                ></button>
                
              </div>
              <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
                <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelRegioni}}</span>
              </div>
              <button 
                pButton type="button" icon="pi pi-cloud-download"
                pTooltip="Esporta i dati" tooltipPosition="top"
                class="font-['Poppins']"
                style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
                (click)="scaricaReport()" 
              ></button>
            </div>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" 
              [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
              [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiFase3Bando1Filtrati" dataKey="impresa"
              >
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-left font-['Poppins']" style="font-size: 10px; width: 10%; ">IMPRESA</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">01. F3 In attesa ODA</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">02. F3 Da Accettare</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">03. F3 Presa in carico</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">04. F3 In lav. Impresa</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">05. F3 Consegnata a SF</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">06. F3 In carico SF</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">07. F3 Presa in carico TIM</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">08. F3 In firma TIM</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">09. F3 Pacchetto Firmato</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">10. F3 PEC a Infratel</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">11. F3 Rework Impresa</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">12. F3 Respinta</th>
                  <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">13. F3 Approvata</th>
                  <th class="text-center font-['Poppins'] font-bold" style="font-size: 9px;width: 5%;">TOTALE</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>
                    <p-tag [value]="(row.impresa | uppercase) || ''"
                      [style]="{
                        'background-color': '#5f9ea0',
                        'color': '#ffffff',
                        'border-radius': '5px',
                        'padding': '.25em .3rem',
                        'font-weight': '700',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'cursor': 'pointer',
                        'display': 'inline-block',
                        'min-width': '50px'
                      }"
                      (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                      tooltipPosition="top">
                      {{row.impresa | uppercase}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.inAttesaODA > 0" [value]="row.inAttesaODA"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'inAttesaODA')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in attesa di ODA' "
                     tooltipPosition="top">
                     {{row.inAttesaODA}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.daAssegnare > 0" [value]="row.daAssegnare"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'daAssegnare')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' da assegnare' "
                     tooltipPosition="top">{{row.daAssegnare}}
                    </p-tag>
                  </td> 
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.inCaricoImpresa > 0" [value]="row.inCaricoImpresa"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'inCaricoImpresa')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in carico all\'impresa' "
                     tooltipPosition="top">{{row.inCaricoImpresa}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.inProgettazione > 0" [value]="row.inProgettazione"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'inProgettazione')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in progettazione' "
                     tooltipPosition="top">{{row.inProgettazione}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.consegnate > 0" [value]="row.consegnate"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'consegnate')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' consegnate' "
                     tooltipPosition="top">{{row.consegnate}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.inVerificaSmartfiber > 0" [value]="row.inVerificaSmartfiber"
                        [style]="{
                          'background-color': '#EBEBEB',
                          'color': '#000000',
                          'border-radius': '5px',
                          'border-color':'#0A0A0A',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '11.5px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                        }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'inVerificaSmartfiber')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in verifica Smartfiber' "
                     tooltipPosition="top">{{row.inVerificaSmartfiber}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.inCaricoPresidio > 0" [value]="row.inCaricoPresidio"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                            }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'inCaricoPresidio')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in carico al presidio' "
                     tooltipPosition="top">{{row.inCaricoPresidio}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.inFirma > 0" [value]="row.inFirma"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'inFirma')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in firma' "
                     tooltipPosition="top">{{row.inFirma}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.firmate > 0" [value]="row.firmate"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'firmate')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' firmate' "
                     tooltipPosition="top">{{row.firmate}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.pubblicate > 0" [value]="row.pubblicate"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'pubblicate')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' pubblicate' "
                     tooltipPosition="top">{{row.pubblicate}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.inReworkAzienda > 0" [value]="row.inReworkAzienda"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'inReworkAzienda')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in rework azienda' "
                     tooltipPosition="top">{{row.inReworkAzienda}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.respinte > 0" [value]="row.respinte"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'respinte')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' respinte' "
                     tooltipPosition="top">{{row.respinte}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']">
                    <p-tag *ngIf="row.approvate > 0" [value]="row.approvate"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                     (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'approvate')"
                     [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' approvate' "
                     tooltipPosition="top">{{row.approvate}}
                    </p-tag>
                  </td>
                
                  <td class="text-center font-['Poppins']">
                    <p-tag  [value]="row.totale"
                      [style]="{
                        'background-color': '#5f9ea0',
                        'color': '#191a1b',
                        'border-radius': '5px',
                        'padding': '.25em .4rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '50px',
                        'cursor': 'pointer',
                       
                      }"
                           (click)="openPraticheFase3DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                           [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                           tooltipPosition="top"
                    >
                      {{row.totale}}
                    </p-tag>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr style="border: none;">
                  <td colspan="1" class="text-left" style="font-size: 11px; font-weight: bold; border: none;">TOTALI:</td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3InAttesaODABando1 > 0" [value]="totaliFase3InAttesaODABando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'inAttesaODA')"
                      [pTooltip]="'Apri TUTTE le pratiche in attesa di ODA' "
                      tooltipPosition="top">
                      {{totaliFase3InAttesaODABando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3DaAssegnareBando1 > 0" [value]="totaliFase3DaAssegnareBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'daAssegnare')"
                      [pTooltip]="'Apri TUTTE le pratiche da assegnare' "
                      tooltipPosition="top">
                      {{totaliFase3DaAssegnareBando1}}
                    </p-tag>
                  </td>
                  
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3InCaricoBando1 > 0" [value]="totaliFase3InCaricoBando1"
                      [style]="{
                          'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'inCaricoImpresa')"
                      [pTooltip]="'Apri TUTTE le pratiche in carico' "
                      tooltipPosition="top">
                      {{totaliFase3InCaricoBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3InProgettazioneBando1 > 0" [value]="totaliFase3InProgettazioneBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'inProgettazione')"
                      [pTooltip]="'Apri TUTTE le pratiche in progettazione' "
                      tooltipPosition="top">
                      {{totaliFase3InProgettazioneBando1}}
                    </p-tag>
                  </td>    
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3ConsegnateBando1 > 0" [value]="totaliFase3ConsegnateBando1"
                      [style]="{
                          'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'consegnate')"
                      [pTooltip]="'Apri TUTTE le pratiche consegnate' "
                      tooltipPosition="top">
                      {{totaliFase3ConsegnateBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3InVerificaSmartfiberBando1 > 0" [value]="totaliFase3InVerificaSmartfiberBando1"
                      [style]="{
                          'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'inVerificaSmartfiber')"
                      [pTooltip]="'Apri TUTTE le pratiche in verifica smartfiber' "
                      tooltipPosition="top">
                      {{totaliFase3InVerificaSmartfiberBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3InCaricoPresidioBando1 > 0" [value]="totaliFase3InCaricoPresidioBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'inCaricoPresidio')"
                      [pTooltip]="'Apri TUTTE le pratiche in carico al presidio' "
                      tooltipPosition="top">
                        {{totaliFase3InCaricoPresidioBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3InFirmaBando1 > 0" [value]="totaliFase3InFirmaBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'inFirma')"
                      [pTooltip]="'Apri TUTTE le pratiche in firma' "
                      tooltipPosition="top">
                      {{totaliFase3InFirmaBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3FirmateBando1 > 0" [value]="totaliFase3FirmateBando1"
                      [style]="{
                          'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                          'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'firmate')"
                      [pTooltip]="'Apri TUTTE le pratiche firmate' "
                      tooltipPosition="top">
                      {{totaliFase3FirmateBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3PubblicateBando1 > 0" [value]="totaliFase3PubblicateBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'pubblicate')"
                      [pTooltip]="'Apri TUTTE le pratiche pubblicate' "
                      tooltipPosition="top">
                      {{totaliFase3PubblicateBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3InReworkAziendaBando1 > 0" [value]="totaliFase3InReworkAziendaBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'inReworkAzienda')"
                      [pTooltip]="'Apri TUTTE le pratiche in rework azienda' "
                      tooltipPosition="top">
                      {{totaliFase3InReworkAziendaBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                    <p-tag *ngIf="totaliFase3RespinteBando1 > 0" [value]="totaliFase3RespinteBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'respinte')"
                      [pTooltip]="'Apri TUTTE le pratiche respinte' "
                      tooltipPosition="top">
                        {{totaliFase3RespinteBando1}}
                    </p-tag>
                  </td>
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                        <p-tag *ngIf="totaliFase3ApprovateBando1 > 0" [value]="totaliFase3ApprovateBando1"
                      [style]="{
                        'background-color': '#828282',
                        'color': '#FFFFFF',
                        'border-radius': '5px',
                        'padding': '.15em .3rem',
                        'font-weight': '800',
                        'font-size': '12px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '20px',
                        'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                      (click)="!isImpresa && openPraticheFase3(1,'approvate')"
                      [pTooltip]="'Apri TUTTE le pratiche approvate' "
                      tooltipPosition="top">
                      {{totaliFase3ApprovateBando1}}
                    </p-tag>
                  </td>         
                  <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag [value]="totaliFase3Bando1"
                      [style]="{
                        'background-color': '#5f9ea0',
                        'color': '#FFFFFF',
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '800',
                        'font-size': '13px',
                        'letter-spacing': '.3px',
                        'display': 'inline-block',
                        'min-width': '50px'
                      }">
                      {{totaliFase3Bando1}}
                    </p-tag>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>
          <p-tabPanel header="Bando 2"> 
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <div>
                <p-dropdown 
                  styleClass="ml-2 fieldFilterControl" 
                  [options]="listeService.opzioniRegioneProntofibra"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="filtraPerRegione($event.value)"
                  placeholder="Regione"
                  [showClear]="false"
                  [filter]="false"
                  [(ngModel)]="filtroRegione"
                />
                <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                  style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
                  pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
                ></button>
              </div>
              <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
                <span class="text-right font-['Poppins']" style="color: #191a1b; font-size: medium; font-weight: 600;">{{labelRegioni}}</span>
              </div>
              <button 
                pButton type="button" icon="pi pi-cloud-download"
                pTooltip="Esporta i dati" tooltipPosition="top"
                class="font-['Poppins']"
                style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
                (click)="scaricaReport()" 
              ></button>
              </div>
              <p-table styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" 
                [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
                [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiFase3Bando2Filtrati" dataKey="impresa"
                >
                <ng-template pTemplate="header">
                  <tr>
                    <th class="text-left font-['Poppins']" style="font-size: 10px; width: 10%; ">IMPRESA</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">01. F3 In attesa ODA</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">02. F3 Da Accettare</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">03. F3 Presa in carico</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">04. F3 In lav. Impresa</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">05. F3 Consegnata a SF</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">06. F3 In carico SF</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">07. F3 Presa in carico TIM</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">08. F3 In firma TIM</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">09. F3 Pacchetto Firmato</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">10. F3 PEC a Infratel</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">11. F3 Rework Impresa</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">12. F3 Respinta</th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px;width: 7%;">13. F3 Approvata</th>
                    <th class="text-center font-['Poppins'] font-bold" style="font-size: 9px;width: 5%;">TOTALE</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr>
                    <td>
                      <p-tag [value]="(row.impresa | uppercase) || ''"
                        [style]="{
                          'background-color': '#5f9ea0',
                          'color': '#ffffff',
                          'border-radius': '5px',
                          'padding': '.25em .3rem',
                          'font-weight': '700',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'cursor': 'pointer',
                          'display': 'inline-block',
                          'min-width': '50px'
                        }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                        tooltipPosition="top">
                        {{row.impresa | uppercase}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inAttesaODA > 0" [value]="row.inAttesaODA"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                      (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'inAttesaODA')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in attesa di ODA' "
                      tooltipPosition="top">{{row.inAttesaODA}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.daAssegnare > 0" [value]="row.daAssegnare"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                      (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'daAssegnare')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' da assegnare' "
                      tooltipPosition="top">{{row.daAssegnare}}
                  </p-tag>
                    </td>
                  
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inCaricoImpresa > 0" [value]="row.inCaricoImpresa"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                      (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'inCaricoImpresa')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in carico all\'impresa' "
                      tooltipPosition="top">{{row.inCaricoImpresa}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inProgettazione > 0" [value]="row.inProgettazione"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                      (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'inProgettazione')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in progettazione' "
                      tooltipPosition="top">{{row.inProgettazione}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.consegnate > 0" [value]="row.consegnate"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                      (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'consegnate')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' consegnate' "
                      tooltipPosition="top">{{row.consegnate}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inVerificaSmartfiber > 0" [value]="row.inVerificaSmartfiber"
                          [style]="{
                            'background-color': '#EBEBEB',
                            'color': '#000000',
                            'border-radius': '5px',
                            'border-color':'#0A0A0A',
                            'padding': '.25em .3rem',
                            'font-weight': '700',
                            'font-size': '11.5px',
                            'letter-spacing': '.3px',
                            'cursor': 'pointer',
                          }"
                      (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'inVerificaSmartfiber')"
                      [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in verifica smartfiber' "
                      tooltipPosition="top">{{row.inVerificaSmartfiber}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inCaricoPresidio > 0" [value]="row.inCaricoPresidio"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'inCaricoPresidio')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa + ' in carico al presidio' "
                        tooltipPosition="top">{{row.inCaricoPresidio}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inFirma > 0" [value]="row.inFirma"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'inFirma')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' +row.impresa + ' in firma' "
                        tooltipPosition="top">{{row.inFirma}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.firmate > 0" [value]="row.firmate"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'firmate')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' +row.impresa + ' firmate' "
                        tooltipPosition="top">{{row.firmate}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.pubblicate > 0" [value]="row.pubblicate"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'pubblicate')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' +row.impresa + ' pubblicate' "
                        tooltipPosition="top">{{row.pubblicate}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.inReworkAzienda > 0" [value]="row.inReworkAzienda"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'inReworkAzienda')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' +row.impresa + ' in rework azienda' "
                        tooltipPosition="top">{{row.inReworkAzienda}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.respinte > 0" [value]="row.respinte"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'respinte')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' +row.impresa + ' respinte' "
                        tooltipPosition="top">{{row.respinte}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']">
                      <p-tag *ngIf="row.approvate > 0" [value]="row.approvate"
                            [style]="{
                              'background-color': '#EBEBEB',
                              'color': '#000000',
                              'border-radius': '5px',
                              'border-color':'#0A0A0A',
                              'padding': '.25em .3rem',
                              'font-weight': '700',
                              'font-size': '11.5px',
                              'letter-spacing': '.3px',
                              'cursor': 'pointer',
                            }"
                        (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'approvate')"
                        [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' +row.impresa + ' approvate' "
                        tooltipPosition="top">{{row.approvate}}
                      </p-tag>
                    </td>
                  
                    <td class="text-center font-['Poppins']">
                      <p-tag  [value]="row.totale"
                        [style]="{
                          'background-color': '#5f9ea0',
                          'color': '#191a1b',
                          'border-radius': '5px',
                          'padding': '.25em .4rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '50px'
                        }"
                       (click)="openPraticheFase3DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                       [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                       tooltipPosition="top">
                        {{row.totale}}
                      </p-tag>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                  <tr style="border: none;">
                    <td colspan="1" class="text-left" style="font-size: 11px; font-weight: bold; border: none;">TOTALI:</td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3InAttesaODABando2 > 0" [value]="totaliFase3InAttesaODABando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }">
                        {{totaliFase3InAttesaODABando2}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3DaAssegnareBando2 > 0" [value]="totaliFase3DaAssegnareBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                        (click)="!isImpresa && openPraticheFase3(2,'daAssegnare')"
                        [pTooltip]="'Apri TUTTE le pratiche da assegnare' "
                        tooltipPosition="top">
                        {{totaliFase3DaAssegnareBando2}}
                      </p-tag>
                    </td>
                    
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3InCaricoBando2 > 0" [value]="totaliFase3InCaricoBando2"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'inCarico')"
                          [pTooltip]="'Apri TUTTE le pratiche in carico' "
                          tooltipPosition="top">
                          {{totaliFase3InCaricoBando2}}
                        </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3InProgettazioneBando2 > 0" [value]="totaliFase3InProgettazioneBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'inProgettazione')"
                          [pTooltip]="'Apri TUTTE le pratiche in progettazione' "
                          tooltipPosition="top">
                          {{totaliFase3InProgettazioneBando2}}
                        </p-tag>
                    </td>
                  
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3ConsegnateBando2 > 0" [value]="totaliFase3ConsegnateBando2"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'consegnate')"
                          [pTooltip]="'Apri TUTTE le pratiche consegnate' "
                          tooltipPosition="top">
                          {{totaliFase3ConsegnateBando2}}
                        </p-tag>
                    </td>
                  
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3InVerificaSmartfiberBando2 > 0" [value]="totaliFase3InVerificaSmartfiberBando2"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'inVerificaSmartfiber')"
                          [pTooltip]="'Apri TUTTE le pratiche in verifica smartfiber' "
                          tooltipPosition="top">
                          {{totaliFase3InVerificaSmartfiberBando2}}
                        </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3InCaricoPresidioBando2 > 0" [value]="totaliFase3InCaricoPresidioBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'inCaricoPresidio')"
                          [pTooltip]="'Apri TUTTE le pratiche in carico al presidio' "
                          tooltipPosition="top">
                            {{totaliFase3InCaricoPresidioBando2}}
                        </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3InFirmaBando2 > 0" [value]="totaliFase3InFirmaBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'inFirma')"
                          [pTooltip]="'Apri TUTTE le pratiche in firma' "
                          tooltipPosition="top">
                          {{totaliFase3InFirmaBando2}}
                        </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3FirmateBando2 > 0" [value]="totaliFase3FirmateBando2"
                        [style]="{
                            'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                            'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'firmate')"
                          [pTooltip]="'Apri TUTTE le pratiche firmate' "
                          tooltipPosition="top">
                          {{totaliFase3FirmateBando2}}
                        </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                        <p-tag *ngIf="totaliFase3PubblicateBando2 > 0" [value]="totaliFase3PubblicateBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'pubblicate')"
                          [pTooltip]="'Apri TUTTE le pratiche pubblicate' "
                          tooltipPosition="top">
                            {{totaliFase3PubblicateBando2}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3InReworkAziendaBando2 > 0" [value]="totaliFase3InReworkAziendaBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'inReworkAzienda')"
                          [pTooltip]="'Apri TUTTE le pratiche in rework azienda' "
                          tooltipPosition="top">
                          {{totaliFase3InReworkAziendaBando2}}
                        </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                      <p-tag *ngIf="totaliFase3RespinteBando2 > 0" [value]="totaliFase3RespinteBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'respinte')"
                          [pTooltip]="'Apri TUTTE le pratiche respinte' "
                          tooltipPosition="top">
                          {{totaliFase3RespinteBando2}}
                      </p-tag>
                    </td>
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                          <p-tag *ngIf="totaliFase3ApprovateBando2 > 0" [value]="totaliFase3ApprovateBando2"
                        [style]="{
                          'background-color': '#828282',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px',
                          'cursor': !isImpresa ? 'pointer' : 'not-allowed'
                          }"
                          (click)="!isImpresa && openPraticheFase3(2,'approvate')"
                          [pTooltip]="'Apri TUTTE le pratiche approvate' "
                          tooltipPosition="top">
                          {{totaliFase3ApprovateBando2}}
                        </p-tag>
                    </td>
                  
                    <td class="text-center font-['Poppins']" style="font-size: 11px; font-weight: bold; border: none;">
                        <p-tag [value]="totaliFase3Bando2"
                        [style]="{
                          'background-color': '#5f9ea0',
                          'color': '#FFFFFF',
                          'border-radius': '5px',
                          'padding': '.15em .3rem',
                          'font-weight': '800',
                          'font-size': '12px',
                          'letter-spacing': '.3px',
                          'display': 'inline-block',
                          'min-width': '20px'
                        }">
                        {{totaliFase3Bando2}}
                      </p-tag>
                    </td>
                  </tr>
                </ng-template>
              </p-table>

          </p-tabPanel>
        </p-tabView>
      </p-tabPanel>
</p-tabView> 